document.addEventListener('DOMContentLoaded', function() {
    const mainMenu = document.querySelector('.main-header .menu');
    const menuItens = document.querySelector('.menu-item');
	const buttonMais = document.querySelector('.fa-angle-down');
    const mainMenuDesk = document.querySelector('.main-header-lateral__menu-desktop .menu');
	const itemWithChild = mainMenuDesk.querySelectorAll('.menu li.menu-item-has-children');

	buttonMais.addEventListener ('click', function(ev) {
		ev.preventDefault();

		if (menuItens.classList.contains('open')) {
			menuItens.classList.remove('open')
		} else {
			menuItens.classList.add('open')
		}
	})

	itemWithChild.forEach(item => {

		if (item.parentElement.classList.contains('sub-menu')){
			return;
		}

		item.querySelector('.fa-angle-down').addEventListener('click', function(e) {
			e.preventDefault();

			item.classList.toggle('active');

		});


	})

	document.addEventListener('click', function(e) {
		if ( e.target.closest('.main-header-lateral__menu-desktop') === null ) {
			let allItens = mainMenu.querySelectorAll('.active');

			allItens.forEach ( function(item) {
				item.classList.remove('active');
			});
		}
	})

	// Scroll
    function throttle(func, delay) {
        let lastFunc;
        let lastRan;
        return function() {
            const context = this;
            const args = arguments;
            if (!lastRan) {
                func.apply(context, args);
                lastRan = Date.now();
            } else {
                clearTimeout(lastFunc);
                lastFunc = setTimeout(function() {
                    if ((Date.now() - lastRan) >= delay) {
                        func.apply(context, args);
                        lastRan = Date.now();
                    }
                }, delay - (Date.now() - lastRan));
            }
        }
    }

    const header = document.querySelector(".main-header-lateral")
    let isScrolled = false

    const detectScroll = throttle(function() {
        const scroll = window.scrollY || document.documentElement.scrollTop;
        const threshold = 100
        const returnPoint = 50

        if (scroll > threshold && !isScrolled) {
            header.classList.add("scrolled")
            isScrolled = true
        } else if (scroll < returnPoint && isScrolled) {
            header.classList.remove("scrolled")
            isScrolled = false
        }
        //closeSubmenus()
    }, 200)

    document.addEventListener('wheel', detectScroll, { passive: true });
    document.addEventListener('touchmove', detectScroll, { passive: true });
    document.addEventListener('scroll', detectScroll, { passive: true });

    // Helper functions
    function searchFieldFocus(element) {
        let searchField = document.querySelector(element)
        if(searchField) {
            setTimeout(function() {
                searchField.focus()
            }, 100)
        }
    }

    function closeSubmenus() {
        const mainMenu = document.querySelector('.main-header .menu')
        const itensWithChild = mainMenu.querySelectorAll('.menu li.menu-item-has-children')

        itensWithChild.forEach(item => {

            item.querySelector('i').addEventListener('click', function(e) {
                e.preventDefault();

                if (item.classList.contains('active')) {
                    item.classList.remove('active')
                }

            });


        })
    }


})
